import { OrderDetailResponse, OrderItem as ApiOrderItem } from "./orderDetail.api";

export interface OrderDetail {
    id?: number;
    order_id?: number;
    order_number?: string;
    group_id?: string;
    representative_id?: string;
    customer_id?: string;
    customer_code?: string;
    branch_code?: string;
    customer?: Customer;
    line_id?: string;
    staff_name?: string;
    type?: string;
    status?: string;
    sales_date?: Date;
    total_amount?: string;
    created_at?: Date;
    updated_at?: Date;
    order_items?: OrderItem[];
}

export interface Customer {
    mt_code?: string;
    branch_code?: string;
    company_out_name?: string;
    company_in_name?: string;
}

export interface OrderItem {
    id?: number;
    item_id?: number;
    product_code?: string;
    product_name?: string;
    origin_code?: string;
    origin_name?: string;
    shipper_code?: string;
    shipper_name?: string;
    grade?: string;
    rank?: string;
    order_unit?: string;
    order_quantity?: number;
    weight?: string;
    package_type?: string;
    quantity_per_package?: number;
    proposed_price?: string;
    line_total?: string;
    notes?: string;
    created_at?: Date;
    updated_at?: Date;
    is_selected: boolean;
}

export const ConvertOrderDetail = (orderDetail: OrderDetailResponse): OrderDetail => {
    return {
        id: orderDetail.id,
        order_id: orderDetail.order_id,
        order_number: orderDetail.order_number,
        group_id: orderDetail.group_id,
        representative_id: orderDetail.representative_id,
        customer_id: orderDetail.customer_id,
        customer_code: orderDetail.customer_code,
        branch_code: orderDetail.branch_code,
        customer: {
            mt_code: orderDetail.customer?.mt_code,
            branch_code: orderDetail.customer?.branch_code,
            company_out_name: orderDetail.customer?.company_out_name,
            company_in_name: orderDetail.customer?.company_in_name,
        },
        line_id: orderDetail.line_id,
        staff_name: orderDetail.staff_name,
        type: orderDetail.type,
        status: orderDetail.status,
        sales_date: orderDetail.sales_date,
        total_amount: orderDetail.total_amount,
        created_at: orderDetail.created_at,
        updated_at: orderDetail.updated_at,
        order_items: orderDetail.order_items?.map((item: ApiOrderItem) => ({
            id: item.id,
            item_id: item.item_id,
            product_code: item.product_code,
            product_name: item.product_name,
            origin_code: item.origin_code,
            origin_name: item.origin_name,
            shipper_code: item.shipper_code,
            shipper_name: item.shipper_name,
            grade: item.grade,
            rank: item.rank,
            order_unit: item.order_unit,
            order_quantity: item.order_quantity,
            weight: item.weight,
            package_type: item.package_type,
            quantity_per_package: item.quantity_per_package,
            proposed_price: item.proposed_price,
            line_total: item.line_total,
            notes: item.notes,
            created_at: item.created_at,
            updated_at: item.updated_at,
            is_selected: true,
        })),
    };
}

export default ConvertOrderDetail;